import { request } from "@/interface/helper";

const str = "inoRecommend";

export const inoRecommend = {
  [`${str}`]: {
    getList: (data) => request({ data, method: "get", url: "/ino/recommend/list" }),
    add: (data) => request({ data, method: "post", url: "/ino/recommend/add" }),
    detail: (data) => request({ data, method: "post", url: "/ino/recommend/detail" }),
    edit: (data) => request({ data, method: "post", url: "/ino/recommend/modify" }),
  },
};
